module.exports = __webpack_public_path__ + "img/home.d4c7a6fd.svg";